export default () => ({
  statusAddress: null,
  statusStaff: null,
  entity: 'price',
  entities: 'prices',
  prefixRouter: 'professional.company.prices'
})



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/data.js